var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{attrs:{"responsive":"md","fields":_vm.data.fields,"items":_vm.data.items,"tbody-tr-class":"my-2"},scopedSlots:_vm._u([{key:"cell(status)",fn:function(row){return [_c('span',{directives:[{name:"show",rawName:"v-show",value:(row.item.status == 0),expression:"row.item.status == 0"}],class:{
                'ok-img': row.item.status === '0',
            }},[_vm._v(" Giá cao nhất ")]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(row.item.status == 1),expression:"row.item.status == 1"}],class:{
                'cancel': row.item.status === '1'
            }},[_vm._v(" Giá thấp hơn ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }